// User Role System
export const USER_ROLES = {
  ADMIN: 'admin',
  MODERATOR: 'moderator',
  MEMBER: 'member',
  GUEST: 'guest',
  SUSPEND: 'suspend'
};

// Role hierarchy (higher number = more permissions)
export const ROLE_HIERARCHY = {
  [USER_ROLES.ADMIN]: 5,
  [USER_ROLES.MODERATOR]: 4,
  [USER_ROLES.MEMBER]: 3,
  [USER_ROLES.GUEST]: 2,
  [USER_ROLES.SUSPEND]: 1
};

// Role display information
export const ROLE_INFO = {
  [USER_ROLES.ADMIN]: {
    label: 'Admin',
    color: 'red',
    bgColor: 'bg-red-100',
    textColor: 'text-red-700',
    description: 'Full system access and user management'
  },
  [USER_ROLES.MODERATOR]: {
    label: 'Moderator',
    color: 'purple',
    bgColor: 'bg-purple-100',
    textColor: 'text-purple-700',
    description: 'Can moderate posts and manage content'
  },
  [USER_ROLES.MEMBER]: {
    label: 'Member',
    color: 'blue',
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-700',
    description: 'Standard user with full posting privileges'
  },
  [USER_ROLES.GUEST]: {
    label: 'Guest',
    color: 'gray',
    bgColor: 'bg-gray-100',
    textColor: 'text-gray-700',
    description: 'Limited access, can view but not post'
  },
  [USER_ROLES.SUSPEND]: {
    label: 'Suspended',
    color: 'orange',
    bgColor: 'bg-orange-100',
    textColor: 'text-orange-700',
    description: 'Account suspended, cannot post or interact'
  }
};

// Permission checks
export const canCreatePost = (userRole) => {
  return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[USER_ROLES.MEMBER];
};

export const canEditPost = (userRole, isOwnPost) => {
  return isOwnPost && ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[USER_ROLES.MEMBER];
};

export const canDeletePost = (userRole, isOwnPost) => {
  return (
    ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[USER_ROLES.MODERATOR] ||
    (isOwnPost && ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[USER_ROLES.MEMBER])
  );
};

export const canModerateContent = (userRole) => {
  return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[USER_ROLES.MODERATOR];
};

export const canManageUsers = (userRole) => {
  return userRole === USER_ROLES.ADMIN;
};

export const canLikePost = (userRole) => {
  return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[USER_ROLES.GUEST];
};

export const canComment = (userRole) => {
  return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[USER_ROLES.MEMBER];
};

export const canEditDefaultThemes = (userRole) => {
  return userRole === USER_ROLES.ADMIN;
};

// Get default role for new users
export const getDefaultRole = () => USER_ROLES.MEMBER;

// Check if user has higher or equal role
export const hasRoleOrHigher = (userRole, requiredRole) => {
  return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole];
};

// Get role badge component props
export const getRoleBadgeProps = (role) => {
  const info = ROLE_INFO[role] || ROLE_INFO[USER_ROLES.GUEST];
  return {
    label: info.label,
    className: `px-3 py-1 ${info.bgColor} ${info.textColor} rounded-full text-sm font-medium`
  };
};
